module.exports = __webpack_public_path__ + "img/section1Bg.6128527f.webp";